type AlertCircleProps = {
  color?: string;
  size?: number;
};

export function AlertCircle({
  color = '#DC2626',
  size = 18
}: AlertCircleProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      color={color}>
      <path
        d="M9 0C4.037 0 0 4.037 0 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9zm0 13.5c-.621 0-1.125-.504-1.125-1.125S8.379 11.25 9 11.25s1.125.504 1.125 1.125S9.621 13.5 9 13.5zm0-9c-.621 0-1.125.504-1.125 1.125v3.75c0 .621.504 1.125 1.125 1.125s1.125-.504 1.125-1.125v-3.75C10.125 5.004 9.621 4.5 9 4.5z"
        fill="currentColor"
      />
    </svg>
  );
}
